import '../../stylus/components/_grid.styl'

import Grid from './grid'

export default Grid('container')



// WEBPACK FOOTER //
// ./src/components/VGrid/VContainer.js